import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
//styles
import './assets/scss/App.scss'

import Movies from './components/Movies/MovieList'
import MovieSingle from './components/Movies/MovieSingle'
import Header from './components/includes/Nav/Header'


class App extends Component {
  render() {
    return (
      <div className="MovieApp">
        <Header/>
        <div className="Movies">
          <Switch>
            <Route exact path="/" component={Movies}/>
            <Route exact path="/:id" component={MovieSingle}/>
          </Switch> 
        </div>
      </div>
    )
  }
}

export default App




// WEBPACK FOOTER //
// ./src/App.js